module.exports = __webpack_public_path__ + "static/WorkSans-Regular-7d761a652f8e716f57f4352b0f4e6280.ttf";